<app-layout>
  <app-voltar route="listagem/funcionario" />
  <div class="desktop">
    <app-titulo>Parametrização de Acessos</app-titulo>
    <div class="header">
      <form class="perfil" [formGroup]="form">
        <app-input
          type="select"
          label="Perfil"
          name="PK_PERF"
          formControlName="PK_PERF"
          [selectData]="perfisData"
          (ngModelChange)="onPerfilChange($event)" />
        <div class="icons">
          <img
            src="assets/add-profile.svg"
            alt="Adicionar"
            (click)="openCadastrarPerfil()" />
          <img
            src="assets/edit.svg"
            alt="Editar"
            (click)="openCadastrarPerfil(true)" />
          <img
            src="assets/del-profile.svg"
            alt="Deletar"
            (click)="deletePerfil()" />
        </div>
      </form>
      <div class="header-buttons">
        <app-botao
          text="Salvar Perfil"
          icon="assets/add.svg"
          (click)="savePerfil()"
          [disabled]="!form.valid" />
      </div>
    </div>
    <div class="select">
      <label class="select-all">
        <input type="checkbox" id="selectAll" (click)="onCheckAll($event)" />
        <span>Selecione todos</span>
      </label>
    </div>
    <div class="tabela">
      <h2>Acessos</h2>
      <app-tabela-parametrizacao-acessos
        [columns]="acessosColumns"
        [data]="acessosData" />
    </div>
    <div class="tabela">
      <h2>Agendamento</h2>
      <app-tabela-parametrizacao-acessos
        [columns]="agendamentoColumns"
        [data]="agendamentoData" />
    </div>
    <div class="tabela">
      <h2>Parametrização</h2>
      <app-tabela-parametrizacao-acessos
        [columns]="parametrizacaoColumns"
        [data]="parametrizacaoData" />
    </div>
    <div class="tabela">
      <h2>Empresas</h2>
      <app-tabela-parametrizacao-acessos
        [columns]="empresasColumns"
        [data]="empresasData" />
    </div>
    <div class="tabela">
      <h2>Gate de Entrada</h2>
      <app-tabela-parametrizacao-acessos
        [columns]="gateDeEntradaColumns"
        [data]="gateDeEntradaData" />
    </div>
    <div class="tabela">
      <h2>Gate de Saída</h2>
      <app-tabela-parametrizacao-acessos
        [columns]="gateSaidaColumns"
        [data]="gateSaidaData" />
    </div>
    <div class="tabela">
      <h2>Serviços</h2>
      <app-tabela-parametrizacao-acessos
        [columns]="servicosColumns"
        [data]="servicosData" />
    </div>
    <div class="tabela">
      <h2>Laudo Higienização</h2>
      <app-tabela-parametrizacao-acessos
        [columns]="laudoHigienizacaoColumns"
        [data]="laudoHigienizacaoData" />
    </div>
    <div class="tabela">
      <h2>Tampas/Grades/Paletes</h2>
      <app-tabela-parametrizacao-acessos
        [columns]="tampasGradesPaletesColumns"
        [data]="tampasGradesPaletesData" />
    </div>
    <div class="tabela">
      <h2>Engate</h2>
      <app-tabela-parametrizacao-acessos
        [columns]="engateColumns"
        [data]="engateData" />
    </div>
    <div class="tabela">
      <h2>Desengate</h2>
      <app-tabela-parametrizacao-acessos
        [columns]="desengateColumns"
        [data]="desengateData" />
    </div>
    <div class="tabela">
      <h2>Caixa</h2>
      <app-tabela-parametrizacao-acessos
        [columns]="caixaColumns"
        [data]="caixaData" />
    </div>
    <div class="tabela">
      <h2>Higienização Agendada</h2>
      <app-tabela-parametrizacao-acessos
        [columns]="higienizacaoAgendadaColumns"
        [data]="higienizacaoAgendadaData" />
    </div>
    <div class="tabela">
      <h2>LOG's</h2>
      <app-tabela-parametrizacao-acessos
        [columns]="logsColumns"
        [data]="logsData" />
    </div>
    <div class="tabela">
      <h2>Motoristas Externo</h2>
      <app-tabela-parametrizacao-acessos
        [columns]="motoristasExternoColumns"
        [data]="motoristasExternoData" />
    </div>
    <div class="tabela">
      <h2>Estoque</h2>
      <app-tabela-parametrizacao-acessos
        [columns]="estoqueColumns"
        [data]="estoqueData" />
    </div>
    <div class="tabela">
      <h2>Relatórios</h2>
      <app-tabela-parametrizacao-acessos
        [columns]="relatoriosColumns"
        [data]="relatoriosData" />
    </div>
    <div class="tabela">
      <h2>Gráficos (por painel)</h2>
      <app-tabela-parametrizacao-acessos
        [columns]="graficosColumns"
        [data]="graficosData" />
    </div>
  </div>
</app-layout>

<app-loader [isLoading]="isLoading" />
